import { Container } from '@/components/MenuDrawer/MyMenuDrawer/SubMenu/Settings/SalesSettings/styles';
import { RadioV2 } from '@/components/@IntranetLibrary/Radio/RadioV2';
import { Controller, useForm } from 'react-hook-form';
import { RadioGroup } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import React, { useEffect, useState } from 'react';
import { AppConfig } from '@/types/api';
import { useAtom } from 'jotai';
import { appSettingState } from '@/recoil/atom';
import { RnMessage, sendToRN } from '@/utils/function';
import { useTranslation } from 'react-i18next';

const DeveloperMode = () => {
  const { t } = useTranslation();
  const [state] = useAtom(appSettingState);

  const [changeState, setChangeState] = useState<Pick<AppConfig, 'server'>>({
    server: state.server,
  });

  const [isChanged, setIsChanged] = useState(false);

  useEffect(() => {
    if (state.server !== changeState.server) {
      setIsChanged(true);
    } else {
      setIsChanged(false);
    }
  }, [changeState]);

  const { control } = useForm<Pick<AppConfig, 'server'>>({
    values: {
      server: changeState.server,
    },
  });

  const handleClick = () => {
    if (confirm('변경된 설정을 적용하기 위해 앱을 재기동합니다.')) {
      sendToRN(RnMessage.CHANGE_DEVELOPER_MODE, { server: changeState.server });
    }
  };

  return (
    <Container>
      <div>
        <Controller
          name={'server'}
          control={control}
          render={({ field: { value } }) => (
            <RadioGroup
              onChange={(e) =>
                setChangeState({ ...state, server: e.target.value })
              }
              value={value}
              sx={{
                '.default': {
                  '&::after': {
                    content: `"${t('사용중')}"`,
                    display: 'inline-block',
                    padding: '4px 12px',
                    borderRadius: '999px',
                    backgroundColor: 'rgba(0, 102, 204, 0.12)',
                    fontSize: '12px',
                    color: 'var(--dk-accent, #0066CC)',
                    marginLeft: 'auto',
                  },
                },
              }}
            >
              <FormControlLabel
                className={state.server === 'product' ? 'default' : ''}
                value={'product'}
                control={<RadioV2 />}
                label="Production"
              />
              <FormControlLabel
                className={state.server === 'stage' ? 'default' : ''}
                value={'stage'}
                control={<RadioV2 />}
                label="Stage"
              />
              <FormControlLabel
                className={state.server === 'dev' ? 'default' : ''}
                value={'dev'}
                control={<RadioV2 />}
                label="Development"
              />
            </RadioGroup>
          )}
        />
      </div>
      <button
        style={{
          borderRadius: '6px',
          padding: '14px',
          color: 'white',
          backgroundColor: 'black',
          width: '100%',
          opacity: isChanged ? '1' : '0.2',
        }}
        disabled={!isChanged}
        onClick={handleClick}
      >
        {t('저장')}
      </button>
    </Container>
  );
};

export default DeveloperMode;
